import {Injectable} from '@angular/core';

import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(private http: HttpClient) {
  }

  getSearchItem(url: string, itemShop : any) {
    let params = new HttpParams();
    params = params.append('item', itemShop.item);
    params = params.append('location', itemShop.location);
    params = params.append('subcategory', itemShop.subcategory != null ? itemShop.subcategory : 'undefined');
    params = params.append('category', itemShop.category != null ? itemShop.category : 'undefined');
    return this.http.get(url + 'search-items', {params:params});
  }

  getCounties(url: string, param: string) {
    return this.http.get(url + param);
  }
}
